import { useGate } from '../../../hooks/useGate';
import { gateNames } from '../../../constants/statsig';

export const useApplicationVideoGates = () => {
  const isProAppVideoEnabled = useGate(gateNames.proAppVideo);
  const isAutopopupEnabled = useGate(gateNames.appVideoAutopopup);

  return {
    isProAppVideoEnabled,
    isAutopopupEnabled,
    isAutoVideoPopupEnabled: isProAppVideoEnabled && isAutopopupEnabled,
  };
};
